const CALENDLY_BASE_URL = 'https://calendly.com';

export const CONCIERGE_SPECIALIST_CALENDLY_URL = `${CALENDLY_BASE_URL}/rollover-concierge/concierge-specialist-consultation`;
export const CONCIERGE_INTRO_CALENDLY_URL = `${CALENDLY_BASE_URL}/rollover-concierge/intro-consultation`;
export const CONCIERGE_EXPERT_CALENDLY_URL = `${CALENDLY_BASE_URL}/rollover-concierge/expert-consultation`;
export const EXPLORING_ADVISOR_NETWORK_CALENDLY_URL = `${CALENDLY_BASE_URL}/rollover-concierge/exploratory-call`;
export const EXPLORING_PREMIUM_CALENDLY_URL = `${CALENDLY_BASE_URL}/betterment-consultation/introduction-to-premium-plan`;
export const FINANCIAL_COACHING_401K_URL = `${CALENDLY_BASE_URL}/betterment-consultation/401k-certified-coaching-call`;
export const PREMIUM_UPGRADE_CALENDLY_URL = `${CALENDLY_BASE_URL}/betterment-consultation/intro-to-premium-plan`;
export const PREMIUM_SOLO_401K_CALENDLY_URL = `${CALENDLY_BASE_URL}/rollover-concierge/solo401k-account-opening`;
export const PREMIUM_SOLO_401K_SCREENER_CALENDLY_URL = `${CALENDLY_BASE_URL}/d/cwsx-b6v-r4h`;

export const TRANSFER_AMOUNTS_CENTS = [
  0, 2000000, 4000000, 6000000, 8000000, 10000000, 15000000, 20000000, 25000000, 50000000, 100000000, 200000000,
];
export const DEFAULT_SLIDER_VALUE = 0;

export const ACCOUNT_TYPE_CHECKBOX_VALUES = [
  {
    name: '401k',
    label: '401(k)',
    index: '1',
  },
  {
    name: 'traditional_ira',
    label: 'Traditional IRA',
    index: '2',
  },
  {
    name: 'roth_ira',
    label: 'Roth IRA',
    index: '3',
  },
  {
    name: 'sep_ira',
    label: 'SEP IRA',
    index: '4',
  },
  {
    name: 'inherited_ira',
    label: 'Inherited IRA',
    index: '5',
  },
  {
    name: 'taxable',
    label: 'Taxable (Brokerage)',
    index: '6',
  },
  {
    name: 'cash',
    label: 'Cash',
    index: '7',
  },
  {
    name: 'pension_plan',
    label: 'Pension Plan',
    index: '8',
  },
  {
    name: 'trust',
    label: 'Trust',
    index: '9',
  },
  {
    name: 'something_else',
    label: 'Something else',
    index: '10',
  },
];

export const SOLO_401K = 'Solo401k';

export const SOLO_401K_SIGNUP_INTENT = 'solo_401k';
